module.exports = __webpack_public_path__ + "static/media/chris_toomey.4921bc31.jpg";